import { Helmet } from "react-helmet-async";

function LegalShell({ title, subtitle, children, testId }) {
  return (
    <>
      <Helmet>
        <title>{`${title} — Salihi Group`}</title>
        <meta name="description" content={`${title} for Salihi Group.`} />
      </Helmet>
      <section data-testid={testId} className="pt-40 pb-24 md:pt-48 md:pb-32 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-5">
            <span className="gold-hairline" />
            <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">Legal</span>
          </div>
          <h1 className="font-serif text-navy text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-[-0.01em]">
            {title}
          </h1>
          {subtitle && <p className="text-mutedink mt-6 text-lg font-light leading-relaxed">{subtitle}</p>}
          <div className="mt-12 prose-navy space-y-6 text-mutedink text-[16px] leading-[1.75] font-light">
            {children}
          </div>
        </div>
      </section>
    </>
  );
}

export default LegalShell;
